import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import MainSidebar from 'components/ui/MainSidebar';
import MarketplaceTabs from 'components/ui/MarketplaceTabs';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';
import CategoryFilters from './components/CategoryFilters';
import SortBar from './components/SortBar';
import ProductCard from './components/ProductCard';
import ProductDetailModal from './components/ProductDetailModal';
import CartDrawer from './components/CartDrawer';
import CheckoutModal from './components/CheckoutModal';
import FeaturedBanner from './components/FeaturedBanner';


const PRODUCTS = [
{
  id: 1,
  name: "Radiance Serum Collection",
  seller: "Glow & Thrive Skincare",
  sellerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_15751363f-1763296851612.png",
  sellerAvatarAlt: "Professional Black woman with natural hair smiling confidently in white lab coat",
  category: "Beauty",
  price: 68.00,
  originalPrice: 85.00,
  rating: 4.8,
  reviewCount: 124,
  winVerified: true,
  badge: "Best Seller",
  image: "https://images.unsplash.com/photo-1681370498478-0680e985f24a",
  imageAlt: "Luxurious gold-tipped serum bottles arranged elegantly on white marble with botanical elements",
  images: [
  "https://images.pexels.com/photos/3762875/pexels-photo-3762875.jpeg",
  "https://images.pexels.com/photos/4041392/pexels-photo-4041392.jpeg",
  "https://images.pexels.com/photos/3685530/pexels-photo-3685530.jpeg"],

  description: "Vitamin C & hyaluronic acid serum for radiant, even-toned skin.",
  fullDescription: "Our award-winning Radiance Serum Collection combines 20% Vitamin C with triple-weight hyaluronic acid and niacinamide to deliver visibly brighter, firmer skin in just 4 weeks. Formulated specifically for melanin-rich skin tones by Dr. Amara Johnson, a board-certified dermatologist.",
  tags: ["skincare", "vitamin-c", "serum", "melanin-skin"],
  popularity: 98,
  createdAt: "2026-02-15",
  reviews: [
  { name: "Tanya M.", avatar: "https://images.unsplash.com/photo-1718609256733-b1c7645735f1", avatarAlt: "Young Black woman with braids smiling outdoors in natural light", rating: 5, date: "Feb 28, 2026", comment: "My skin has never looked better! The glow is real and it doesn't irritate my sensitive skin." },
  { name: "Keisha R.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_128683b30-1763296674609.png", avatarAlt: "Professional woman with short natural hair in business casual attire", rating: 5, date: "Feb 20, 2026", comment: "Finally a serum made for us! The hyperpigmentation on my cheeks has faded significantly." },
  { name: "Priya S.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1bac54d6b-1772144003159.png", avatarAlt: "South Asian woman with long dark hair smiling warmly in casual setting", rating: 4, date: "Feb 10, 2026", comment: "Love the texture and the results. Shipping was fast too!" }]

},
{
  id: 2,
  name: "SmartHome Hub Pro",
  seller: "TechHer Solutions",
  sellerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1db9f1f64-1763300298225.png",
  sellerAvatarAlt: "Indian-American woman engineer with glasses in modern tech office environment",
  category: "Tech",
  price: 129.99,
  rating: 4.6,
  reviewCount: 87,
  winVerified: true,
  badge: "New",
  image: "https://images.unsplash.com/photo-1511842745775-b366af36db2a",
  imageAlt: "Sleek white smart home hub device on modern minimalist desk with ambient lighting",
  images: [
  "https://images.pexels.com/photos/4219654/pexels-photo-4219654.jpeg",
  "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg"],

  description: "Voice-controlled smart home hub compatible with all major platforms.",
  fullDescription: "The SmartHome Hub Pro connects seamlessly with Alexa, Google Home, and Apple HomeKit. Features include energy monitoring, automated routines, and a privacy-first design with a physical mic mute button. Designed by women engineers who understand what a smart home should actually do.",
  tags: ["smart-home", "tech", "voice-control", "energy"],
  popularity: 76,
  createdAt: "2026-03-01",
  reviews: [
  { name: "Lisa K.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_187457db0-1772272115962.png", avatarAlt: "White woman with blonde hair in casual home setting smiling at camera", rating: 5, date: "Mar 5, 2026", comment: "Setup was incredibly easy and it works with everything I own. Love it!" },
  { name: "Diane W.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1099b95e2-1772868872172.png", avatarAlt: "Middle-aged woman with curly hair in home office with bookshelves behind her", rating: 4, date: "Feb 25, 2026", comment: "Great product. The energy monitoring feature alone is worth the price." }]

},
{
  id: 3,
  name: "Artisan Honey Gift Set",
  seller: "Harvest & Bloom Foods",
  sellerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1a872bbed-1772101824095.png",
  sellerAvatarAlt: "Latina woman with warm smile wearing apron in artisan food production kitchen",
  category: "Food",
  price: 42.00,
  rating: 4.9,
  reviewCount: 203,
  winVerified: true,
  badge: null,
  image: "https://images.unsplash.com/photo-1603445215995-fb465c635535",
  imageAlt: "Beautiful gift set of artisan honey jars with wooden dipper on rustic wooden board with wildflowers",
  images: [
  "https://images.unsplash.com/photo-1587049352846-4a222e784d38?w=600",
  "https://images.unsplash.com/photo-1558642452-9d2a7deb7f62?w=600"],

  description: "Three varieties of raw, small-batch honey from our family apiary.",
  fullDescription: "Our Artisan Honey Gift Set includes three 8oz jars of raw, unfiltered honey: Wildflower, Lavender Infused, and Cinnamon Spice. Harvested from our family-owned apiary in Vermont using sustainable beekeeping practices. Perfect for gifting or treating yourself.",
  tags: ["honey", "organic", "gift", "artisan", "food"],
  popularity: 95,
  createdAt: "2026-01-20",
  reviews: [
  { name: "Rachel B.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_122b2230e-1772094574910.png", avatarAlt: "Young woman with red hair smiling in kitchen with natural light", rating: 5, date: "Mar 3, 2026", comment: "The lavender honey is absolutely divine. Ordered three sets as gifts!" },
  { name: "Monique T.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10efed71a-1772095451593.png", avatarAlt: "Black woman with natural hair in cozy home setting holding tea mug", rating: 5, date: "Feb 18, 2026", comment: "Best honey I've ever tasted. You can really taste the difference from store-bought." }]

},
{
  id: 4,
  name: "Linen Throw Blanket",
  seller: "Casa Bella Home",
  sellerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_173d37eed-1772124378177.png",
  sellerAvatarAlt: "Hispanic woman interior designer with warm smile in beautifully decorated living room",
  category: "Home",
  price: 89.00,
  rating: 4.7,
  reviewCount: 56,
  winVerified: false,
  badge: null,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_13c48688e-1772318989684.png",
  imageAlt: "Soft cream linen throw blanket draped elegantly over modern gray sofa in bright living room",
  images: [
  "https://images.pexels.com/photos/6186812/pexels-photo-6186812.jpeg"],

  description: "100% European linen throw, pre-washed for ultimate softness.",
  fullDescription: "Crafted from 100% European flax linen, this throw blanket gets softer with every wash. Available in 8 neutral tones to complement any decor. Pre-washed for immediate softness. Dimensions: 50\" x 70\". Machine washable.",
  tags: ["home-decor", "linen", "blanket", "sustainable"],
  popularity: 62,
  createdAt: "2026-02-01",
  reviews: [
  { name: "Sarah J.", avatar: "https://images.unsplash.com/photo-1662878857891-6447f6b88294", avatarAlt: "Woman with brown hair in cozy home setting wrapped in blanket reading book", rating: 5, date: "Feb 22, 2026", comment: "Absolutely gorgeous and so soft. Worth every penny!" }]

},
{
  id: 5,
  name: "Mindful Mornings Journal",
  seller: "Inkwell & Co.",
  sellerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_17fd75071-1772868864408.png",
  sellerAvatarAlt: "Creative Black woman author with natural hair at writing desk surrounded by books",
  category: "Books",
  price: 28.00,
  rating: 4.9,
  reviewCount: 312,
  winVerified: true,
  badge: "Community Favorite",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_135201754-1772868873542.png",
  imageAlt: "Beautiful hardcover journal with gold foil lettering on navy cover beside morning coffee and pen",
  images: [
  "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=600",
  "https://images.unsplash.com/photo-1531346878377-a5be20888e57?w=600"],

  description: "90-day guided journal for financial goals, gratitude, and wealth mindset.",
  fullDescription: "The Mindful Mornings Journal is a 90-day guided journal specifically designed for women building wealth. Each day includes prompts for financial goal-setting, gratitude practice, affirmations, and reflection. Includes a wealth tracker, vision board pages, and monthly review sections. Hardcover with gold foil accents.",
  tags: ["journal", "mindfulness", "wealth", "goals", "women"],
  popularity: 99,
  createdAt: "2026-01-05",
  reviews: [
  { name: "Aisha C.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_185d73bc8-1772147601277.png", avatarAlt: "Professional Black woman with natural hair smiling confidently in business attire", rating: 5, date: "Mar 6, 2026", comment: "This journal changed my relationship with money. On my third one now!" },
  { name: "Jennifer L.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_171517b36-1763295397686.png", avatarAlt: "Asian-American woman with long dark hair in bright modern workspace", rating: 5, date: "Mar 1, 2026", comment: "The prompts are so thoughtful and specific to women's financial journeys." }]

},
{
  id: 6,
  name: "Yoga Flow Mat & Strap Set",
  seller: "Zenith Wellness Co.",
  sellerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ab4dedd3-1767813275948.png",
  sellerAvatarAlt: "Athletic woman yoga instructor with serene expression in bright yoga studio",
  category: "Wellness",
  price: 74.00,
  rating: 4.5,
  reviewCount: 89,
  winVerified: false,
  badge: null,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d841e994-1772098421715.png",
  imageAlt: "Premium purple yoga mat rolled out with matching strap and block on clean wooden floor",
  images: [
  "https://images.pexels.com/photos/4056535/pexels-photo-4056535.jpeg"],

  description: "Eco-friendly non-slip yoga mat with alignment lines and carrying strap.",
  fullDescription: "Our Yoga Flow Mat is made from natural tree rubber with a microfiber top layer for superior grip. Features alignment lines for proper positioning. Includes a matching cotton carrying strap. 6mm thickness for joint support. Available in 5 colors. Eco-certified materials.",
  tags: ["yoga", "wellness", "eco-friendly", "fitness"],
  popularity: 71,
  createdAt: "2026-02-10",
  reviews: [
  { name: "Maya P.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_156519492-1772186391889.png", avatarAlt: "Fit woman with athletic build in yoga attire smiling after workout session", rating: 5, date: "Feb 28, 2026", comment: "Best mat I\'ve ever used. The grip is incredible even when sweaty." }]

},
{
  id: 7,
  name: "Power Blazer - Navy",
  seller: "Elevate Fashion Studio",
  sellerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_134804217-1772868874549.png",
  sellerAvatarAlt: "Stylish Black fashion designer woman in chic outfit in modern fashion studio",
  category: "Fashion",
  price: 195.00,
  rating: 4.8,
  reviewCount: 47,
  winVerified: true,
  badge: "WIN Pick",
  image: "https://images.unsplash.com/photo-1672364428567-f75dce9b568f",
  imageAlt: "Professional navy blue power blazer displayed on mannequin with gold button accents in boutique setting",
  images: [
  "https://images.pexels.com/photos/1036623/pexels-photo-1036623.jpeg",
  "https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg"],

  description: "Structured power blazer in deep navy with gold button details. Sizes 0-22.",
  fullDescription: "The Power Blazer is designed for the woman who means business. Crafted from Italian wool blend fabric with a structured silhouette that flatters all body types. Features gold button accents, two functional pockets, and a fully lined interior. Available in sizes 0-22. Dry clean recommended.",
  tags: ["fashion", "blazer", "professional", "plus-size", "navy"],
  popularity: 84,
  createdAt: "2026-02-20",
  reviews: [
  { name: "Vanessa H.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ee492086-1772204294242.png", avatarAlt: "Professional woman in business attire with confident posture in corporate office", rating: 5, date: "Mar 4, 2026", comment: "I wore this to my board presentation and got so many compliments. Fits perfectly!" }]

},
{
  id: 8,
  name: "Wireless Productivity Earbuds",
  seller: "TechHer Solutions",
  sellerAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1db9f1f64-1763300298225.png",
  sellerAvatarAlt: "Indian-American woman engineer with glasses in modern tech office environment",
  category: "Tech",
  price: 149.00,
  rating: 4.4,
  reviewCount: 63,
  winVerified: true,
  badge: null,
  image: "https://images.unsplash.com/photo-1592324938482-c4197bc4925c",
  imageAlt: "Premium white wireless earbuds in charging case on clean white surface with soft shadows",
  images: [
  "https://images.pexels.com/photos/3394650/pexels-photo-3394650.jpeg"],

  description: "Active noise cancellation earbuds with 32-hour battery life.",
  fullDescription: "Designed for the busy professional woman, these earbuds feature active noise cancellation, transparency mode, and 32-hour total battery life with the charging case. IPX5 water resistant. Includes three ear tip sizes for a perfect fit. Compatible with all devices via Bluetooth 5.2.",
  tags: ["tech", "earbuds", "wireless", "productivity"],
  popularity: 68,
  createdAt: "2026-03-05",
  reviews: [
  { name: "Christine O.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1e3c9d637-1768783455870.png", avatarAlt: "Professional woman with headphones working at laptop in modern coworking space", rating: 4, date: "Mar 6, 2026", comment: "Great sound quality and the noise cancellation is excellent for open offices." }]

}];


const SIDEBAR_WIDTH = 240;
const SIDEBAR_COLLAPSED_WIDTH = 64;

export default function WinMarketplaceProducts() {
  const navigate = useNavigate();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [activeCategory, setActiveCategory] = useState('all');
  const [sortBy, setSortBy] = useState('popular');
  const [viewMode, setViewMode] = useState('grid');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);
  const [checkoutOpen, setCheckoutOpen] = useState(false);

  const sidebarWidth = sidebarCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH;

  const filteredProducts = useMemo(() => {
    let result = [...PRODUCTS];

    if (activeCategory !== 'all') {
      result = result?.filter((p) => p?.category?.toLowerCase() === activeCategory);
    }

    if (searchQuery?.trim()) {
      const q = searchQuery?.toLowerCase();
      result = result?.filter((p) =>
      p?.name?.toLowerCase()?.includes(q) ||
      p?.seller?.toLowerCase()?.includes(q) ||
      p?.description?.toLowerCase()?.includes(q) ||
      p?.tags?.some((t) => t?.includes(q))
      );
    }

    switch (sortBy) {
      case 'newest':result?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));break;
      case 'price_asc':result?.sort((a, b) => a?.price - b?.price);break;
      case 'price_desc':result?.sort((a, b) => b?.price - a?.price);break;
      case 'rating':result?.sort((a, b) => b?.rating - a?.rating);break;
      default:result?.sort((a, b) => b?.popularity - a?.popularity);
    }

    return result;
  }, [activeCategory, sortBy, searchQuery]);

  const handleAddToCart = (product, qty = 1) => {
    setCartItems((prev) => {
      const existing = prev?.find((i) => i?.id === product?.id);
      if (existing) {
        return prev?.map((i) => i?.id === product?.id ? { ...i, qty: i?.qty + qty } : i);
      }
      return [...prev, { ...product, qty }];
    });
  };

  const handleRemoveFromCart = (id) => {
    setCartItems((prev) => prev?.filter((i) => i?.id !== id));
  };

  const handleUpdateQty = (id, qty) => {
    if (qty <= 0) {handleRemoveFromCart(id);return;}
    setCartItems((prev) => prev?.map((i) => i?.id === id ? { ...i, qty } : i));
  };

  const handleCheckout = () => {
    setCartOpen(false);
    setCheckoutOpen(true);
  };

  const handleCheckoutClose = () => {
    setCheckoutOpen(false);
    setCartItems([]);
  };

  const cartCount = cartItems?.reduce((s, i) => s + i?.qty, 0);
  const cartTotal = cartItems?.reduce((s, i) => s + i?.price * i?.qty, 0);
  const isInCart = (id) => cartItems?.some((i) => i?.id === id);

  return (
    <div className="min-h-screen" style={{ background: 'var(--color-surface)' }}>
      <MainSidebar isCollapsed={sidebarCollapsed} onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)} />
      {/* Main Content */}
      <div
        className={`transition-all duration-250 min-h-screen pb-20 lg:pb-0 ${sidebarCollapsed ? 'lg:ml-[64px]' : 'lg:ml-[240px]'}`}>
        
        {/* Top Header */}
        <header className="sticky top-0 z-30 flex items-center justify-between px-4 md:px-6 lg:px-8"
        style={{ height: 'var(--header-height)', background: 'var(--color-primary)', borderBottom: '1px solid rgba(133,113,77,0.2)' }}>
          <div className="flex items-center gap-3 pl-10 lg:pl-0">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: 'rgba(133,113,77,0.15)' }}>
              <Icon name="ShoppingBag" size={18} color="var(--color-accent)" />
            </div>
            <div>
              <h1 className="font-heading font-bold text-lg md:text-xl text-white leading-tight">WIN Marketplace</h1>
              <p className="font-caption text-xs hidden md:block" style={{ color: 'rgba(255,255,255,0.6)' }}>
                Support women-owned businesses
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            {/* Cart Button */}
            <button
              onClick={() => setCartOpen(true)}
              className="relative flex items-center gap-2 px-3 py-2 rounded-lg transition-all"
              style={{ background: 'rgba(133,113,77,0.15)', border: '1px solid rgba(133,113,77,0.3)' }}
              aria-label={`Shopping cart with ${cartCount} items`}>
              
              <Icon name="ShoppingCart" size={18} color="var(--color-accent)" />
              <span className="font-caption text-sm font-medium hidden sm:block" style={{ color: 'var(--color-accent)' }}>
                ${cartTotal?.toFixed(2)}
              </span>
              {cartCount > 0 &&
              <span className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full flex items-center justify-center font-caption text-xs font-bold"
              style={{ background: 'var(--color-accent)', color: 'var(--color-accent-foreground)' }}>
                  {cartCount}
                </span>
              }
            </button>

            {/* Profile */}
            <div className="w-9 h-9 rounded-full overflow-hidden border-2 cursor-pointer" style={{ borderColor: 'var(--color-accent)' }}
            onClick={() => navigate('/profile')}>
              <img src="https://img.rocket.new/generatedImages/rocket_gen_img_1dc8fa372-1772868863789.png" alt="Current user profile - professional woman with natural hair" className="w-full h-full object-cover" />
            </div>
          </div>
        </header>

        {/* Marketplace Tabs */}
        <div className="px-4 md:px-6 lg:px-8 pt-4" style={{ background: 'var(--color-background)', borderBottom: '1px solid var(--color-border)' }}>
          <MarketplaceTabs activeTab="products" onTabChange={(tab) => {
            if (tab === 'services') navigate('/win-marketplace-products');
            if (tab === 'merch') navigate('/win-marketplace-products');
          }} />
        </div>

        <main className="px-4 md:px-6 lg:px-8 py-6 pb-24 lg:pb-8 space-y-6">
          {/* Featured Banner */}
          <FeaturedBanner onShopNow={(item) => {
            const product = PRODUCTS?.find((p) => p?.seller === item?.title?.split(' ')?.slice(0, 2)?.join(' ')) || PRODUCTS?.[0];
            setSelectedProduct(product);
          }} />

          {/* Stats Strip */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {[
            { label: 'Women-Owned Sellers', value: '247', icon: 'Crown', color: 'var(--color-accent)' },
            { label: 'Products Available', value: '1,840', icon: 'Package', color: 'var(--color-primary)' },
            { label: 'Orders This Month', value: '3,291', icon: 'ShoppingBag', color: 'var(--color-success)' },
            { label: 'Community Reviews', value: '12.4K', icon: 'Star', color: 'var(--color-warning)' }]?.
            map((stat) =>
            <div key={stat?.label} className="flex items-center gap-3 p-3 md:p-4 rounded-xl border"
            style={{ background: 'var(--color-card)', borderColor: 'var(--color-border)' }}>
                <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ background: `${stat?.color}18` }}>
                  <Icon name={stat?.icon} size={18} color={stat?.color} />
                </div>
                <div className="min-w-0">
                  <div className="font-data font-bold text-base md:text-lg" style={{ color: 'var(--color-foreground)' }}>{stat?.value}</div>
                  <div className="font-caption text-xs line-clamp-1" style={{ color: 'var(--color-muted-foreground)' }}>{stat?.label}</div>
                </div>
              </div>
            )}
          </div>

          {/* Filters & Sort */}
          <div className="space-y-4">
            <CategoryFilters
              activeCategory={activeCategory}
              onCategoryChange={setActiveCategory}
              resultCount={filteredProducts?.length} />
            
            <SortBar
              sortBy={sortBy}
              onSortChange={setSortBy}
              viewMode={viewMode}
              onViewModeChange={setViewMode}
              searchQuery={searchQuery}
              onSearchChange={setSearchQuery} />
            
          </div>

          {/* Product Grid / List */}
          {filteredProducts?.length === 0 ?
          <div className="flex flex-col items-center justify-center py-16 gap-4">
              <div className="w-16 h-16 rounded-full flex items-center justify-center" style={{ background: 'var(--color-muted)' }}>
                <Icon name="SearchX" size={28} color="var(--color-muted-foreground)" />
              </div>
              <h3 className="font-heading font-semibold text-xl" style={{ color: 'var(--color-foreground)' }}>No products found</h3>
              <p className="font-caption text-sm text-center" style={{ color: 'var(--color-muted-foreground)' }}>
                Try adjusting your filters or search query
              </p>
              <Button variant="outline" onClick={() => {setActiveCategory('all');setSearchQuery('');}}>
                Clear Filters
              </Button>
            </div> :
          viewMode === 'grid' ?
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
              {filteredProducts?.map((product) =>
            <ProductCard
              key={product?.id}
              product={product}
              onAddToCart={handleAddToCart}
              onViewDetail={setSelectedProduct}
              isInCart={isInCart(product?.id)}
              viewMode="grid" />

            )}
            </div> :

          <div className="space-y-3">
              {filteredProducts?.map((product) =>
            <ProductCard
              key={product?.id}
              product={product}
              onAddToCart={handleAddToCart}
              onViewDetail={setSelectedProduct}
              isInCart={isInCart(product?.id)}
              viewMode="list" />

            )}
            </div>
          }

          {/* Submit Business CTA */}
          <div className="rounded-2xl p-6 md:p-8 text-center"
          style={{ background: 'var(--color-primary)', border: '2px solid rgba(133,113,77,0.3)' }}>
            <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4"
            style={{ background: 'rgba(133,113,77,0.15)' }}>
              <Icon name="Store" size={24} color="var(--color-accent)" />
            </div>
            <h3 className="font-heading font-bold text-xl md:text-2xl text-white mb-2">
              Own a Women-Led Business?
            </h3>
            <p className="font-caption text-sm md:text-base mb-6" style={{ color: 'rgba(255,255,255,0.75)' }}>
              Join 247+ women entrepreneurs selling on the WIN Marketplace. Get access to our community of 10,000+ members ready to support your business.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Button variant="default" iconName="Plus" iconPosition="left">
                Submit Your Business
              </Button>
              <Button variant="outline" iconName="Info" iconPosition="left">
                Learn More
              </Button>
            </div>
          </div>
        </main>
      </div>
      {/* Product Detail Modal */}
      {selectedProduct &&
      <ProductDetailModal
        product={selectedProduct}
        onClose={() => setSelectedProduct(null)}
        onAddToCart={handleAddToCart}
        isInCart={isInCart(selectedProduct?.id)} />

      }
      {/* Cart Drawer */}
      <CartDrawer
        isOpen={cartOpen}
        onClose={() => setCartOpen(false)}
        cartItems={cartItems}
        onRemove={handleRemoveFromCart}
        onUpdateQty={handleUpdateQty}
        onCheckout={handleCheckout} />
      
      {/* Checkout Modal */}
      <CheckoutModal
        isOpen={checkoutOpen}
        onClose={handleCheckoutClose}
        total={cartTotal + (cartTotal > 75 ? 0 : 8.99)}
        itemCount={cartCount} />
      
    </div>);

}